import React from 'react';
import CodeRegistrationContainer from 'containers/auth/CodeRegistrationContainer';

export default function CodeRegistration() {
  return <CodeRegistrationContainer />;
}
